import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryDropdownComponent } from './category-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [CategoryDropdownComponent],
  exports: [CategoryDropdownComponent],
})
export class CategoryDropdownModule { }
